import React, { FC, ReactNode } from 'react';
import { EasyModal } from '@ui';
import useTranslation from '@app/hooks/use-translation';

type RemovalModalPropsType = {
  onClose(): void;
  show: boolean;
  handleDelete(): void;
  description: string | ReactNode;
};

const RemovalModal: FC<RemovalModalPropsType> = (props) => {
  const { onClose, show, description, handleDelete } = props;
  const { t } = useTranslation('common.forms');

  return (
    <EasyModal
      withoutFooter
      onClose={onClose}
      label={t('warning')}
      show={show}
      variant="removal"
      onRemove={handleDelete}
    >
      <div className="flex items-center justify-center text-center">{description}</div>
    </EasyModal>
  );
};

export default RemovalModal;
